<div class="fieldset" [ngClass]="{ invalid: invalid }">
  <div class="fieldset-info">
    <span class="fieldset__title">{{ title }}</span>
    <span class="fieldset__helper">{{ helper }}</span>
  </div>
  <div class="fieldset-content">
    <ng-content></ng-content>
  </div>
</div>
